export const site_data = {
   "people_enabled": true,
   "site_name": "Fussel Gallery"
};